import { tryJsonParse } from '../json/try-json-parse';

const deepCloneObject = <T>(obj: T): T => {
    if (obj === null || obj === undefined) {
        return obj;
    }

    if (typeof obj === 'object' || Array.isArray(obj)) {
        const { parsedJson } = tryJsonParse<T>(JSON.stringify(obj));
        return parsedJson ?? ({} as T);
    }

    throw new Error('Input must be an object, array, null, or undefined.');
};

export { deepCloneObject };
